// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  guildId: __t.u64().primaryKey().name("guild_id"),
  hallStructureId: __t.u64().name("hall_structure_id"),
  name: __t.string(),
  tag: __t.string(),
  founder: __t.identity(),
  leaderId: __t.identity().name("leader_id"),
  motd: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
});
